import React from "react";
import moment from "moment/moment";

const HistoryPregnant = ({visit}) => {

    return (
        <>
            <div className='card' style={{ width: '100%', marginBottom: 0 }}>
                <div
                    className='card-header bg-success text-white collapsed'
                    id={"headinglaby"}
                    data-toggle='collapse'
                    data-target={"#collapselaby"}
                    aria-expanded='false'
                    aria-controls={"collapselaby"}
                >
                    <h4 className={'mb-0 text-white'}>Riwayat Kehamilan</h4>
                </div>
                <div
                    className='collapse'
                    id={"collapselaby"}
                    aria-labelledby={"headinglaby"}>
                    <div className='card-body'>
                        <div className='accordion' style={{width: '100%'}}>
                            {visit.pregnant.map((data, key) =>
                                data.log === false ? (
                                    <div className='card' key={key}>
                                        <div
                                            className='card-header collapsed'
                                            id={"headinglab" + key}
                                            data-toggle='collapse'
                                            data-target={"#collapselab" + key}
                                            aria-expanded='false'
                                            aria-controls={"collapselab" + key}>
                                            <div className='row align-items-center'>
                                                <div className='col'>
                                                    <div className='mb-0 text-default'>
                                                        Tanggal Kunjungan{" "}
                                                        {moment(data.created_at).format("DD-MM-YYYY HH:mm")}
                                                    </div>
                                                    <div className='h3 mb-0 text-default h4'>
                                                        Paramedis {data.users.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className='collapse'
                                            id={"collapselab" + key}
                                            aria-labelledby={"headinglab" + key}>
                                            <div className='card-body'>
                                                <div className='list-group mb-4'>
                                                    <div className='list-group-item mt-0 mb-0'>
                                                        <div className='h4 text-center mb-0'>DETAIL KEHAMILAN</div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            {data.medical_facilities_other ? (
                                                                <>
                                                                    <div className='col-12'>
                                  <span className=''>
                                    Berkunjung ke nakes lain sebelumnya
                                  </span>
                                                                    </div>
                                                                    <div className='col-1'></div>
                                                                    <div className='col-3'>
                                                                        <span className=''>Umur Kehamilan</span>
                                                                    </div>
                                                                    <div className='col-8'>
                                  <span className='h4'>
                                    {data.medical_facilities_other_age} minggu
                                  </span>
                                                                    </div>
                                                                    <div className='col-1'></div>
                                                                    <div className='col-3'>
                                                                        <span className=''>Tempat</span>
                                                                    </div>
                                                                    <div className='col-8'>
                                  <span className='h4'>
                                    {data.health_facilities?.name}
                                  </span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className='col-12'>
                                  <span className='text-muted'>
                                    Tidak berkunjung ke nakes lain sebelumnya
                                  </span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-12'>
                                                                <span className=''>Data Suami</span>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        Nama Suami
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.husband_name, 'husband_name', 'text');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.husband_name}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>

                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        No Handphone Suami
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.husband_phone, 'husband_phone', 'text');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.husband_phone}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-12'>
                                                                <span className=''>Riwayat Persalinan</span>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        G
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.g, 'g', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.g}
                                                                    </button>
                                                                </div>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        P
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.p, 'p', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.p}
                                                                    </button>
                                                                </div>
                                                                <div className='btn-group btn-group-toggle'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        A
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.a, 'a', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.a}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-12'>
                                                                <span className=''>HPHT & HPL</span>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        HPHT
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.hpht, 'hpht', 'date');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {moment(data.hpht).format("DD-MM-YYYY")}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        HPL
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.htp, 'htp', 'date');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {moment(data.htp).format("DD-MM-YYYY")}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-12'>
                                                                <span className=''>Jumlah Anak</span>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        Hidup
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.alive_child, 'alive_child', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.alive_child}
                                                                    </button>
                                                                </div>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        Mati
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.dead_child, 'dead_child', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.dead_child}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <div className='btn-group btn-group-toggle mr-2'>
                                                                    <label className='btn btn-secondary active border-light'>
                                                                        Prematur
                                                                    </label>
                                                                    <button
                                                                        onClick={() => {
                                                                            putSpecisif(data.id, data.premature_child, 'premature_child', 'number');
                                                                        }}
                                                                        className='btn btn-secondary border-light'>
                                                                        {data.premature_child}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-6'>
                                                                <span className=''>Tahun pernikahan</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.married_year, 'married_year', 'number');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.married_year}
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-6'>
                                                              <span className=''>
                                                                Jarak dengan persalinan sebelumnya
                                                              </span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.childbirth_interval, 'childbirth_interval', 'number');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.childbirth_interval} tahun
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-6'>
                                                                <span className=''>LILA</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.lila, 'lila', 'number');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.lila} cm
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-6'>
                                                              <span className=''>
                                                                Berat badan sebelum hamil
                                                              </span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.weight, 'weight', 'number');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.weight} kg
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-6'>
                                                                <span className=''>Tinggi badan</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.height, 'height', 'number');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.height} cm
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-6'>
                                                                <span className=''>Golongan Darah</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.blood_type?.name ?? '-'}
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-6'>
                                                                <span className=''>IMT</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.imt ?? ''}
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-6'>
                                                                <span className=''>Screening imunisasi TT</span>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.immunization_screening_tt, 'immunization_screening_tt', 'text', ['tt1', 'tt2', 'tt3', 'tt4', 'tt5']);
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.immunization_screening_tt}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='list-group-item mt-0 mb-0'>
                                                        <div className='h4 text-center'>
                                                            FAKTOR RISIKO & KOMPLIKASI
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-4'>
                                                                <span className=''>Faktor Risiko</span>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.risk_factor, 'risk_factor', 'text');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.risk_factor === '' ? '-' : data.risk_factor}
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                                            <div className='col-md-4'>
                                                                <span className=''>Komplikasi</span>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.complication, 'complication', 'text');
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    <span className='h4'>{data.complication === '' ? '-' : data.complication}</span>
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className='row pb-2 pt-2 ml-1 mr-1'>
                                                            <div className='col-md-4'>
                                                                <span className=''>Ditemukan Oleh</span>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                <button
                                                                    onClick={() => {
                                                                        putSpecisif(data.id, data.found_by, 'found_by', 'text', ['nakes', 'masyarakat']);
                                                                    }}
                                                                    className='btn btn-secondary border-light'>
                                                                    {data.found_by}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/*<table className="table table-striped table-bordered" style={{width: 576}}>*/}
            {/*    <tbody>*/}
            {/*    <tr className="bg-secondary">*/}
            {/*        <th style={{ padding: "12Px" }}>*/}
            {/*            <div style={{position: 'relative'}}>*/}
            {/*                <div className="text-black text-center h4">*/}
            {/*                    RIWAYAT KEHAMILAN*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </th>*/}
            {/*    </tr>*/}
            {/*    {show && <tr>*/}
            {/*        <td>*/}
            {/*            */}
            {/*        </td>*/}
            {/*    </tr>}*/}
            {/*    </tbody>*/}
            {/*</table>*/}
        </>
    )
}

export default HistoryPregnant